import { defineMessages } from 'react-intl';

const messages = defineMessages({
    mailSubscribeEmail: {
        id:'mailSubscribeEmail',
        defaultMessage: 'Email',
        description: 'Text for the place holder in mail subscribe box.',
    },
    mailSubscribeSubmit: {
        id:'mailSubscribeSubmit',
        defaultMessage: 'Submit',
        description: 'Text for the button in mail subscribe box.',
    },
});

export default messages;
